import { useEffect, useState } from "react";
import "./ScrollUpButton.scss";

type ScrollUpButtonProps = {
    onBeforeScroll?: () => void
}

const ScrollUpButton = ({ onBeforeScroll }: ScrollUpButtonProps) => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            setIsVisible(window.scrollY > window.innerHeight);
        }

        handleScroll()

        window.addEventListener("scroll", handleScroll)

        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])

    const handleClick = () => {
        onBeforeScroll?.();

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }

    if (!isVisible) return null

    return (
        <button
            className="scrollUpButton"
            type="button"
            onClick={handleClick}
        >
            <img src="/arrow.svg" alt="" className="scrollUpButton_arrow" />
        </button>
    )
}

export default ScrollUpButton